export default function () {
  setWindowHeight()

  window.addEventListener('resize', setWindowHeight)
}

// See: https://dev.to/maciejtrzcinski/100vh-problem-with-ios-safari-3ge9
function setWindowHeight() {
  document.documentElement.style.setProperty('--bnotk-window-height', `${window.innerHeight}px`)
}
